import { render, staticRenderFns } from "./DabPlayerComponent.vue?vue&type=template&id=71ba8b09&scoped=true"
import script from "./DabPlayerComponent.vue?vue&type=script&lang=ts"
export * from "./DabPlayerComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ba8b09",
  null
  
)

export default component.exports